var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.457 67.8125C53.457 64.4146 50.7026 61.6602 47.3047 61.6602H22.6953C19.2974 61.6602 16.543 64.4146 16.543 67.8125V70H53.457V67.8125Z",
    fill: "#D8890B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8984 16.543V12.4414H40.7746C40.155 10.704 38.7882 9.33721 37.0508 8.7176V0H32.9492V8.7176C31.2118 9.33721 29.845 10.704 29.2254 12.4414H4.10156V16.543H9.22906L0 39.1016C0 44.7553 4.60018 49.3555 10.2539 49.3555H14.3555C20.0092 49.3555 24.6094 44.7553 24.6094 39.1016L15.3386 16.543H29.2255C29.8452 18.2804 31.2119 19.6472 32.9494 20.2668V49.5802C28.9414 50.4004 25.7709 53.5492 24.9538 57.5586H45.0465C44.2293 53.5492 41.0588 50.4004 37.0509 49.5802V20.2668C38.7883 19.6472 40.1551 18.2804 40.7747 16.543H54.6198L45.3906 39.1016C45.3906 44.7553 49.9908 49.3555 55.6445 49.3555H59.7461C65.3998 49.3555 70 44.7553 70 39.1016L60.7292 16.543H65.8984ZM19.4819 37.0508H5.1275L12.3047 19.8234L19.4819 37.0508ZM64.8725 37.0508H50.5181L57.6953 19.8234L64.8725 37.0508Z",
    fill: "#D8890B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.5037381b.svg";
export { ForwardRef as ReactComponent };